import { Text } from '@hg/stylizator/typography'
import * as React from 'react'
import styled from 'styled-components'

interface Props extends React.ComponentProps<typeof Link> {
  isActive?: boolean
}

const PaginateLink: React.FC<Props> = ({ children, isActive, ...props }) => (
  <Link {...props} data-active={isActive}>
    <Text type="body" color="currentColor">
      <span>{children}</span>
    </Text>
  </Link>
)

export default PaginateLink

const Link = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 32px;
  height: 32px;
  border-radius: 4px;
  color: ${(props) => props.theme.color.gray[50]};

  &:hover,
  &[data-active='true'] {
    color: ${(props) => props.theme.color.blue[60]};
    background-color: ${(props) => props.theme.color.blue[20]};
  }
`
